export default __webpack_public_path__ + "static/media/hydra_image_default_empty_strip.034391c7.png";